import React from 'react';
import Layout from 'Components/Layout';

const UpdateRuleGroupLayout = () => {
    return <Layout>Update Rule Group</Layout>;
};

export default UpdateRuleGroupLayout;
